export enum ToggleVariant {
  On = 'on',
  Off = 'off',
}

export enum ExperimentTreatment {
  Control = 'control',
  Variant = 'variant',
}
